"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatVAT = exports.formatSIREN = exports.formatSIRET = exports.toVAT = exports.toSIREN = exports.isVAT = exports.isSIRET = exports.isSIREN = void 0;
var re = {
    SIRET: /^\d{14}$/,
    SIREN: /^\d{9}$/,
    VAT: /^FR\d{11}$/,
    formatSIRET: /^(\d{3})(\d{3})(\d{3})(\d{5})$/g,
    formatSIREN: /(\d\d\d\B)/g,
    formatVAT: /^([A-Z]{2})(\d{2})(\d{3})(\d{3})(\d{3})$/,
};
/**
 * Return TRUE if the string evaluation on the Luhn algorithm succeeds
 */
function checkLuhn(value) {
    var digit;
    var sum = 0;
    var even = false;
    for (var i = value.length - 1; i >= 0; i -= 1) {
        digit = parseInt(value[i], 10);
        if (even) {
            digit += digit;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
        even = !even;
    }
    return (sum % 10) === 0;
}
/**
 * Return the french VAT key for a SIREN
 */
function getVATKey(siren) {
    return (12 + (3 * (parseInt(siren, 10) % 97))) % 97;
}
/**
 * Return TRUE if the VAT is correct
 */
function checkVAT(vat) {
    var siren = vat.substr(4);
    return getVATKey(siren) === parseInt(vat.substr(2, 2), 10) && checkLuhn(siren);
}
/**
 * Return TRUE if the SIREN is valid
 */
function isSIREN(siren) {
    return re.SIREN.test(siren) && checkLuhn(siren);
}
exports.isSIREN = isSIREN;
/**
 * Return TRUE if the SIRET is valid
 */
function isSIRET(siret) {
    return re.SIRET.test(siret) && checkLuhn(siret);
}
exports.isSIRET = isSIRET;
/**
 * Return TRUE if the VAT is valid
 */
function isVAT(vat) {
    return re.VAT.test(vat) && checkVAT(vat);
}
exports.isVAT = isVAT;
/**
 * Convert a SIREN / SIRET / VAT to a SIREN
 */
function toSIREN(value) {
    if (isSIRET(value)) {
        return value.substr(0, 9);
    }
    if (isVAT(value)) {
        return value.substr(4);
    }
    if (isSIREN(value)) {
        return value;
    }
    return '';
}
exports.toSIREN = toSIREN;
/**
 * Convert a SIREN / SIRET / VAT to a VAT
 */
function toVAT(value) {
    if (isVAT(value)) {
        return value;
    }
    var siren = toSIREN(value);
    if (siren) {
        var key = getVATKey(siren);
        return "FR" + (key < 10 ? '0' : '') + key + siren;
    }
    return '';
}
exports.toVAT = toVAT;
/**
 * Format (prettify) a SIRET
 */
function formatSIRET(value) {
    if (!isSIRET(value)) {
        return value;
    }
    return value.replace(re.formatSIRET, '$1 $2 $3 $4');
}
exports.formatSIRET = formatSIRET;
/**
 * Format (prettify) a SIREN
 */
function formatSIREN(value) {
    if (!isSIREN(value)) {
        return value;
    }
    return value.replace(re.formatSIREN, '$1 ');
}
exports.formatSIREN = formatSIREN;
/**
 * Format (prettify) a VAT
 */
function formatVAT(value) {
    if (!isVAT(value)) {
        return value;
    }
    return value.replace(re.formatVAT, '$1 $2 $3 $4 $5');
}
exports.formatVAT = formatVAT;
//# sourceMappingURL=index.js.map